$(document).ready(function() {
          let hasRun = false; // Flag to ensure the script runs only once
      
          // Function to check for .yotpo-sr-bottom-line-text and process them
          function checkAndProcessReviews() {
              if (!hasRun && $('.yotpo-sr-bottom-line-text').length > 0) {
                  clearInterval(checkExist); // Stop checking after processing
                  hasRun = true; // Mark that the script has run
      
                  // Iterate through each .yotpo-sr-bottom-line-text element
                  $('.yotpo-sr-bottom-line-text').each(function() {
                      let container = $(this).closest('.bundle-yotpo-holder'); // Check if the parent is .bundle-yotpo-holder
                      let totalReviews = 0;
      
                      // Handle .bundle-yotpo-holder case
                      if (container.length > 0) {
                          // Ensure we run the logic once per container by setting a custom flag on the container
                          if (!container.data('reviews-summed')) {
                              container.find('.yotpo-sr-bottom-line-text').each(function() {
                                  const reviewCount = parseInt($(this).text().trim().replace(' Reviews', ''));
                                  if (!isNaN(reviewCount)) {
                                  //    console.log('adding this to my review count ' + reviewCount);
                                      totalReviews += reviewCount;
                                  }
                              });
      
                              // Format the totalReviews number with commas
                              let formattedReviews = totalReviews.toLocaleString();
                            //  console.log('my formatted reviews are ' + formattedReviews);
      
                              // Update only the first review field within the current container
                              container.find('.yotpo-sr-bottom-line-text').first().text(formattedReviews + ' Reviews');
                              container.find('.custom-star-bundle').css('opacity', '1');
      
                              // Mark this container as processed
                              container.data('reviews-summed', true);
                          }
      
                      } else {
                          // Handle case where the parent is NOT .bundle-yotpo-holder
                          let textContent = $(this).text().trim();
                          let reviewCount = parseInt(textContent.replace(' Reviews', '').trim());
      
                          // Only format if the number doesn't already contain commas
                          if (!isNaN(reviewCount) && !textContent.includes(',')) {
                              let formattedCount = reviewCount.toLocaleString();
                              $(this).text(formattedCount + ' Reviews');
                          }
                      }
                  });
              }
          }
      
          // Check every 500 milliseconds (adjust the time if needed)
          let checkExist = setInterval(checkAndProcessReviews, 1500);
      });
      